import { render } from "./ProductsInfo.vue?vue&type=template&id=1afaaa33"
import script from "./ProductsInfo.vue?vue&type=script&lang=js"
export * from "./ProductsInfo.vue?vue&type=script&lang=js"

import "./ProductsInfo.vue?vue&type=style&index=0&id=1afaaa33&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__